import ls from "local-storage";

export const normalizeRoleNames = (role) => {
  if (!role) {
    return [];
  }

  if (typeof role === "string") {
    const normalizedRole = role.trim();
    return normalizedRole ? [normalizedRole] : [];
  }

  if (Array.isArray(role)) {
    return role
      .flatMap((entry) => normalizeRoleNames(entry))
      .filter((roleName, index, allRoles) => allRoles.indexOf(roleName) === index);
  }

  if (typeof role === "object" && typeof role.name === "string") {
    const normalizedRole = role.name.trim();
    return normalizedRole ? [normalizedRole] : [];
  }

  return [];
};

export const getRoleNamesFromUser = (user) => {
  if (!user || !Array.isArray(user.roles)) {
    return [];
  }

  return user.roles
    .flatMap((role) => normalizeRoleNames(role));
};

export const getPrimaryRoleFromUser = (user) => getRoleNamesFromUser(user)[0] || "";

export const getStoredRoleNames = () => {
  const storedRoles = normalizeRoleNames(ls.get("roles"));
  if (storedRoles.length > 0) {
    return storedRoles;
  }

  return getRoleNamesFromUser(ls.get("user"));
};

export const persistStoredRole = (role) => {
  const normalizedRole = normalizeRoleNames(role)[0] || false;

  ls.set("roles", normalizedRole);

  if (typeof window !== "undefined") {
    if (normalizedRole) {
      window.localStorage.setItem("roles", normalizedRole);
    } else {
      window.localStorage.removeItem("roles");
    }
  }

  return normalizedRole;
};

export const persistStoredUser = (user) => {
  ls.set("user", user || false);
  return user || false;
};

export const syncRoleToggleEligibility = ({ user, role } = {}) => {
  const roleNames = getRoleNamesFromUser(user);
  const currentEligibility = ls.get("roleToggleEligible") === true;
  const nextEligibility =
    currentEligibility ||
    role === "Super Admin" ||
    roleNames.includes("Super Admin") ||
    Number(user?.is_role_toggled) === 1;

  ls.set("roleToggleEligible", nextEligibility);

  if (typeof window !== "undefined") {
    window.localStorage.setItem("roleToggleEligible", String(nextEligibility));
  }

  return nextEligibility;
};

export const canCurrentUserToggleRole = ({ user, role } = {}) => {
  const roleNames = getRoleNamesFromUser(user);

  return (
    ls.get("roleToggleEligible") === true ||
    role === "Super Admin" ||
    roleNames.includes("Super Admin") ||
    Number(user?.is_role_toggled) === 1
  );
};
